import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    limit: 20,
    page: 1,
    total: 0,
    totalPages: 1,
};

export const blogPageSlice = createSlice({
    name: "blogPageSlice",
    initialState,
    reducers: {
        setBlogPageLimit: (state, action) => {
            state.limit = action.payload;
        },
        setBlogCurrentPage: (state, action) => {
            state.page = action.payload;
        },
        setBlogTotalCount: (state, action) => {
            state.total = action.payload;
        },
        setBlogTotalPages: (state, action) => {
            state.totalPages = action.payload;
        },
        resetBlogPagination: (state, action) => {
            state.limit = 20;
            state.page = 1;
            state.total = 0;
            state.totalPages = 1;
        },
    },
});

export const {
    setBlogPageLimit,
    setBlogCurrentPage,
    setBlogTotalCount,
    setBlogTotalPages,
    resetBlogPagination,
} = blogPageSlice.actions;

export default blogPageSlice.reducer;
